var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWalkIn = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  x: 0.5,
  y: 0.5,
  fill: "#CCD4DD",
  rx: 12
})), /*#__PURE__*/React.createElement("mask", {
  id: "walk-in_svg__a",
  width: 19,
  height: 19,
  x: 3,
  y: 3,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M3.929 3.93h17.143v17.143H3.929z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#walk-in_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0E1218",
  d: "m8.93 20.357 2-10.071-1.287.5v2.428H8.215V9.857l3.607-1.536c.167-.071.342-.113.527-.125.184-.011.36.012.527.072.166.06.324.143.473.25.149.107.27.244.366.41l.714 1.143c.31.5.73.911 1.26 1.233.529.321 1.133.482 1.812.482v1.428c-.834 0-1.578-.172-2.233-.518a5.737 5.737 0 0 1-1.678-1.321l-.447 2.196 1.5 1.429v5.357h-1.428v-4.643l-1.5-1.143-1.286 5.786h-1.5Zm4.642-12.5c-.393 0-.73-.14-1.009-.42-.28-.28-.42-.616-.42-1.008 0-.393.14-.73.42-1.01.28-.28.616-.419 1.009-.419.393 0 .73.14 1.009.42.28.28.42.616.42 1.009 0 .392-.14.729-.42 1.008-.28.28-.616.42-1.009.42Z"
}))));
SvgWalkIn.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgWalkIn);
export default ForwardRef;